import React, { Fragment, useState } from "react";
import numeral from "numeral";
//
//component
import Countdown from "react-countdown";
import { Spin, Typography } from "antd";
import ButtonResent from "component/register/button_resent";
//redux
//selector
//actions
//utils
//hook
//str
const VerifyCountdown = ({ setCountdown, ...props }) => {
  // -------------------------- VAR -----------------------------
  const checking = props?.checking || false;
  const countdown = props?.countdown || null;

  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderChecking = () => {
    if (checking) {
      return (
        <div className="mt-20" style={{ textAlign: "center" }}>
          <Spin spinning />
          <Typography.Text style={{ marginLeft: 5 }}>
            {" "}
            Đang kiểm tra
          </Typography.Text>
        </div>
      );
    }
  };

  const renderCode = () => {
    const disabled = countdown !== null || loading;
    if (countdown) {
      return (
        <div className="mt-20">
          <Typography.Text>
            Mã OTP đã được gửi tới email của bạn, vui lòng kiểm tra hộp thư.
          </Typography.Text>
          <Typography.Text> Mã sẽ hết hạn trong vòng: </Typography.Text>
          <Countdown
            date={countdown}
            onComplete={() => setCountdown(null)}
            renderer={({ minutes, seconds }) => {
              return (
                <span className="hightlight">
                  {minutes}:{numeral(seconds).format("00")}
                </span>
              );
            }}
          />
        </div>
      );
    }
    return (
      <div className="mt-20">
        <Typography.Text>
          Vui lòng kiểm tra hộp thư spam hoặc bạn có thể bấm vào
        </Typography.Text>
        <span>
          <ButtonResent setLoading={setLoading} disabled={disabled} />
        </span>
        <Typography.Text>Để nhận lại mã mới.</Typography.Text>
      </div>
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <Fragment>
      {renderChecking()}
      {renderCode()}
    </Fragment>
  );
};
export default VerifyCountdown;
